// Builds the single-line answer the boost picker sends back into the chat.
//
// It emits exactly ONE selected object id (the object the user actually picked,
// never the account/opportunity parents the picker derives for its summary
// cards). That keeps the handoff unambiguous for the agent's persistence tool
// (boost_fieldlens_request), whose schema requires exactly one of account_id,
// opportunity_id, or support_case_id. The Field Lens id is emitted as a bare
// integer so it binds cleanly to that tool's positive-integer field_lens_id.
export function buildBoostAnswer({
  fieldLensId = null,
  fieldLensName = null,
  selectionType,
  selectionId,
  justification
}) {
  const namePart = fieldLensName ? ` "${fieldLensName}"` : ''
  const idPart = fieldLensId != null && fieldLensId !== ''
    ? ` (Field Lens id: ${fieldLensId})`
    : ''

  return `Boost selection for Field Lens request${namePart}${idPart}. `
    + `Selected ${selectionType} id: ${selectionId}. `
    + `Justification: ${justification}`
}
